import React, { Suspense, useEffect, useState } from 'react'

import { renderRoutes } from 'react-router-config'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress, Modal, Backdrop, Fade, Grid, Divider, Button, Typography } from '@material-ui/core'
import { useAuth } from 'hooks/useAuth'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { WithAuth } from 'providers/withAuth'
import { NavBar, TopBar } from './components'
import { ButtonWithLoading } from 'components/ButtonWithLoading'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  topBar: {},
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },
  navBar: {
    zIndex: 3,
    width: (props) => (props.isNavBarExpanded ? 256 : 70),
    minWidth: (props) => (props.isNavBarExpanded ? 256 : 70),
    flex: '0 0 auto',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: 400,
    }),
    overflowX: 'hidden',
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease',
  },

  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    margin: theme.spacing(4),
    height: '500px',
    overflow: 'auto',
  },
  tituloEspelho: {
    fontSize: '16px',
  },
  corpoEspelho: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(1),
  },
  botaoVoltar: {
    marginTop: '15px',
  },
}))

export const Dashboard = (props) => {
  const { route } = props
  const [isNavBarExpanded, setIsNavBarExpanded] = useState(true)
  const classes = useStyles({ isNavBarExpanded })
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)
  const usuarioService = useUsuarioService()
  const { currentUser, getProfile, signOut } = useAuth()
  const [aberto, setAberto] = useState(false)
  const [processandoOperacao, setProcessandoOperacao] = useState(false)

  useEffect(() => {
    if (!currentUser?.termoConfidencialidade) {
      setAberto(true)
    } else {
      setAberto(false)
    }
  }, [currentUser])

  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true)
  }

  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false)
  }

  const handleAceitarTermoConfidencialidade = () => {
    try {
      usuarioService.aceitarTermoConfidencialidade(setProcessandoOperacao)
      getProfile() // CONTINUAR DAQUI!!
    } catch (err) {
      console.log('Erro ao aceitar o termo de confidencialidade')
    }
  }

  const handleToggleNavBar = () => {
    setIsNavBarExpanded((prev) => !prev)
  }

  const deslogar = () => {
    signOut()
  }
  return (
    <WithAuth>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={aberto}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        // style={{ overflowY: 'auto' }}
      >
        <Fade in={aberto}>
          <Grid container className={classes.paper}>
            <Grid item md={12} sm={12} xs={12}>
              <Typography className={classes.tituloEspelho}>
                <b>TERMO DE CONFIDENCIALIDADE - LGPD</b>
              </Typography>
              <Divider />
            </Grid>

            <Grid item container spacing={2} style={{ paddingTop: '20px' }}>
              <Grid item style={{ textAlign: 'justify' }}>
                <Typography>
                  Declaro, para os devidos fins e efeitos, que me responsabilizo integralmente pela adequada utilização dos dados pessoais e dados pessoais sensíveis a que tiver acesso, estando ciente de que posso vir a ser responsabilizado civil, criminal e administrativamente pelos danos morais ou
                  materiais decorrentes da utilização, reprodução ou divulgação indevida dos dados sobre os deveres, requisitos e responsabilidades decorrentes da Lei n. 13.709, de 14 de agosto de 2018, Lei Geral de Proteção de Dados Pessoais – LGPD, sobre as formas de coleta, tratamento e
                  compartilhamento de dados. Conforme redação do artigo 5º, incisos I e II da Lei n. 13.709, que trata do conceito de dados pessoais e dados pessoais sensíveis:
                </Typography>
              </Grid>

              <Grid item style={{ textAlign: 'justify', paddingLeft: '40px' }}>
                <Typography>
                  <i>
                    Art. 5º Para os fins desta Lei, considera-se: <br />
                    <br />
                    I - dado pessoal: informação relacionada a pessoa natural identificada ou identificável; <br />
                    II - dado pessoal sensível: dado pessoal sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando
                    vinculado a uma pessoa natural;
                  </i>
                </Typography>
              </Grid>

              <Grid item style={{ textAlign: 'justify' }}>
                <Typography>
                  Declaro conhecimento sobre as medidas de segurança, técnicas e administrativas, aptas a proteger os dados pessoais e dados pessoais sensíveis de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de
                  tratamento inadequado ou ilícito; e de que a responsabilidade de qualquer pessoa que intervenha em uma das fases abrangidas pelo fluxo dos dados subsiste mesmo após o término do tratamento.
                </Typography>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Divider />
              </Grid>
            </Grid>

            <Grid container justifyContent="space-between" className={classes.buttons} alignContent="center" alignItems="center">
              <Grid item>
                <Button aria-controls="customized-menu" onClick={deslogar} variant="contained" size="small" className={classes.botaoVoltar}>
                  Rejeitar
                </Button>
              </Grid>
              <Grid item>
                <ButtonWithLoading color="secondary" isDisabled={processandoOperacao} size="small" type="submit" variant="contained" label="Aceitar" isLoading={processandoOperacao} onClick={() => handleAceitarTermoConfidencialidade()} />
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Modal>
      <div className={classes.root}>
        <div className={classes.container}>
          <NavBar className={classes.navBar} onMobileClose={handleNavBarMobileClose} openMobile={openNavBarMobile} isExpanded={isNavBarExpanded} onToggleExpand={handleToggleNavBar} />
          <main className={classes.content}>
            <TopBar className={classes.topBar} onOpenNavBarMobile={handleNavBarMobileOpen} />

            <Suspense fallback={<LinearProgress />}>{renderRoutes(route.routes)}</Suspense>
          </main>
        </div>
      </div>
    </WithAuth>
  )
}
